module.exports = __webpack_public_path__ + "img/8M.79e4e58d.jpg";